import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import '../styles/Sesion.css'

function Sesion(props) {
    const { login } = props;
    const [validated, setValidated] = useState(false);
    const [user, setUser] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        setValidated(false);

        if (form.checkValidity() === false) {
            setValidated(true);
        }
        else {
            login(user, password);
        }
    };

    return (
        <Form noValidate validated={validated} onSubmit={handleSubmit} className='card card-container'>
            <img
                src='//ssl.gstatic.com/accounts/ui/avatar_2x.png'
                alt='profile-img'
                className='profile-img-card'
            />
            <h3 className='login-label'>Iniciar Sesión</h3>
            <Form.Group>
                <Form.Label>Usuario</Form.Label>
                <Form.Control
                    required
                    type='text'
                    placeholder='Ingresa tu usuario'
                    value={user}
                    onChange={(e) => setUser(e.target.value)}
                />
                <Form.Control.Feedback type='invalid'>El usuario es requerido.</Form.Control.Feedback>
            </Form.Group>
            <Form.Group>
                <Form.Label>Contraseña</Form.Label>
                <Form.Control
                    required
                    type='password'
                    placeholder='Ingresa tu contraseña'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <Form.Control.Feedback type='invalid'>La contraseña es requerida.</Form.Control.Feedback>
            </Form.Group>
            <Button variant='dark' type='submit'>Enviar</Button>
        </Form>
    );
}

export default Sesion;